import { MODAL_UPGRADE_PLAN } from '@components/App/Modal/constants'
import { openModal } from '@storeOld/reducers/ui'

import { PLAN_FREE, PRO_PLANS } from '@/constants/userSubscriptionPlans'

const nextPlanType = (planId: string) => {
  if (planId === PLAN_FREE) {
    return 'pro'
  }

  if (PRO_PLANS.includes(planId)) {
    return 'team'
  }

  return null
}

/**
 * The upsell one step up from the current plan: Free → Pro, Pro → Team.
 * Team and Agency have no next plan, so there is nothing to open — callers
 * skip both the modal and the toast's upgrade link in that case.
 */
export const upgradeModal = (planId: string, slideType: string) => {
  const planType = nextPlanType(planId)

  if (!planType) {
    return null
  }

  return openModal({
    modalType: MODAL_UPGRADE_PLAN,
    modalProps: { planType, slideType },
  })
}
